import api from "@beeldit/core/helpers/api";

async function get(endpoint: string, id: number, queryParams: string = "") {
  return await api.get(`/${endpoint}/${id}${queryParams}`);
}

export default get;
